module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['nav-sub', _vm.store && 'nav-sub-store', _vm.st && 'fixed']
  }, [_c('div', {
    class: ['nav-sub-wrapper', 'w', _vm.store && 'nav-sub-store-wrapper', _vm.st && 'fixed']
  }, [(!_vm.store) ? _c('div', {
    staticClass: "nav-list1"
  }, [_c('div', {
    staticClass: "title",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.toGoodsList($event)
      }
    }
  }, [_vm._v("\n        所有分类\n        "), _c('div', {
    staticClass: "cate-pop-div"
  }, [_c('ul', {
    staticClass: "cate-pop1 cate-pop",
    on: {
      "mouseleave": _vm.handleMouseleaveUl
    }
  }, [_vm._l((_vm.cateList), function(item, index) {
    return [_c('li', {
      key: item.category_name,
      on: {
        "mouseenter": function($event) {
          return _vm.handleMouseenterLi(index)
        }
      }
    }, [_c('div', {
      staticClass: "cate-pop-lv1"
    }, [_c('a', {
      staticClass: "cate-pop-lv1-text",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selCate(1, item)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.category_name) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "cate-pop-lv2"
    }, _vm._l((item.children), function(childItem, childIndex) {
      return _c('div', {
        key: childIndex,
        staticClass: "cate-pop-lv2-text"
      }, [_c('a', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.selCate(2, childItem, item)
          }
        }
      }, [_vm._v(_vm._s(childItem.category_name))])])
    }), 0)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.subCateIndex),
        expression: "index === subCateIndex"
      }],
      staticClass: "sub-cate"
    }, _vm._l((item.children), function(childItem, childIndex) {
      return _c('div', {
        key: childIndex,
        staticClass: "item"
      }, [_c('a', {
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.selCate(2, childItem, item)
          }
        }
      }, [_vm._v(_vm._s(childItem.category_name))]), _vm._v(" "), _c('div', {
        staticClass: "menu-2-line"
      }, [_vm._v("|")]), _vm._v(" "), _vm._l((childItem.children), function(v) {
        return (childItem.children) ? _c('div', {
          key: v.category_name,
          staticClass: "menu-2",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.selCate(3, childItem, item, v)
            }
          }
        }, [_c('a', {}, [_vm._v(_vm._s(v.category_name))])]) : _vm._e()
      })], 2)
    }), 0), _vm._v(" "), (index > 8 || index + 1 != _vm.cateList.length) ? _c('div', {
      staticClass: "cate-pop-line"
    }) : _vm._e()])]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav-list2"
  }, [(_vm.store) ? _c('li', {
    class: [_vm.store && 'primary-color'],
    on: {
      "click": function($event) {
        return _vm.change(-2)
      }
    }
  }, [_vm._v("店铺首页")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.change(-1)
      }
    }
  }, [_vm._v("全部商品")]), _vm._v(" "), _vm._l((_vm.data), function(v) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.change(v)
        }
      }
    }, [_vm._v(_vm._s(v.tab))])
  })], 2), _vm._v(" "), (_vm.store) ? _c('div', {
    staticClass: "searchbar-small"
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnterSearch($event)
      }
    },
    model: {
      value: (_vm.searchVal),
      callback: function($$v) {
        _vm.searchVal = $$v
      },
      expression: "searchVal"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "iconfont icon-search",
    on: {
      "click": _vm.onEnterSearch
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-933a7ae8","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/nav.vue
// module id = 715
// module chunks = 0 2 4 5 8 10 11 14 15 16 17 18